"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloudCommon_en_us = void 0;
function cloudCommon_en_us() {
    return {
        "cloudpricing.booking.nowforfree": "Get it for free",
        "cloudpricing.booking.trial": "Test 14 days for free",
        "cloudpricing.booking.confirmation.title": "Confirm Booking",
        "cloudpricing.booking.confirmation.message": "Hereby you confirm the booking of the following subscription:",
        "cloudpricing.booking.confirmation.submessage": "Prices are exclusive taxes. Already paid subscription fees will be prorated proportionally.",
        "cloudpricing.booking.confirmation.subnotfound": "The given subscription was not found.",
        "cloudpricing.booking.confirmation.booknow": "Book now",
        "cloudpricing.booking.alreadybooked": "currently booked",
        "cloudpricing.booking.changeplan": "Change Plan",
        "cloudpricing.booking.cancel": "Cancel Plan",
        "cloudpricing.booking.trialuntil": "Trial until ",
        "cloudpricing.booking.cancelledat": "Cancelled for ",
        "cloudpricing.booking.errors.missingbillingaddress": "You have to add a valid billing address to your company before you can book a subscription",
        "cloudpricing.booking.errors.usernotvalidated": "Please validate your e-mail address before booking a subscription",
        "cloudpricing.free": "Free",
        "cloudpricing.basic": "Basic",
        "cloudpricing.standard": "Standard",
        "cloudpricing.premium": "Premium",
        "cloudpricing.groups.content.title": "Content",
        "cloudpricing.groups.workflows.title": "Workflows",
        "cloudpricing.groups.dashboards.title": "Dashboards",
        "cloudpricing.groups.pim.title": "Products & Shops",
        "cloudpricing.groups.applications.title": "Applications",
        "cloudpricing.groups.general.title": "General",
        "cloudpricing.groups.extensions.title": "Extensions",
        "cloudpricing.features.checkin.limits.appamount": "Check-In Apps",
        "cloudpricing.features.optin.limits.amount": "User Opt-Ins",
        "cloudpricing.features.workflow.title": "Workflows",
        "cloudpricing.features.workflow.limits.amount": "Amount",
        "cloudpricing.features.workflow.limits.executionamount": "Executions per Month",
        "cloudpricing.features.dashboards.title": "Dashboards",
        "cloudpricing.features.dashboards.limits.amount": "Amount",
        "cloudpricing.features.dashboards.limits.widgetamount": "Widgets per Dashboard",
        "cloudpricing.features.dashboards.limits.layouts": "Layouts",
        "cloudpricing.features.applications.title": "Applications",
        "cloudpricing.features.applications.limits.amount": "Amount",
        "cloudpricing.features.applications.limits.theme": "Theme",
        "cloudpricing.features.applications.limits.customcss": "Custom CSS",
        "cloudpricing.features.applications.limits.customdomains": "Custom Domains",
        "cloudpricing.features.applications.limits.pwasupport": "Progressive Web App Support",
        "cloudpricing.features.cms.title": "Content",
        "cloudpricing.features.cms.limits.pageamount": "Page Count",
        "cloudpricing.features.cms.limits.calendaramount": "Calendars",
        "cloudpricing.features.cms.limits.filestoragegbamount": "File Storage (in GB)",
        "cloudpricing.features.cms.limits.formamount": "Forms",
        "cloudpricing.features.cms.limits.i18n": "Internationalization",
        "cloudpricing.features.cms.limits.optins": "Opt-Ins",
        "cloudpricing.features.cms.limits.blogamount": "Blogs",
        "cloudpricing.features.cms.limits.blogpostamount": "Blog Posts",
        "cloudpricing.features.cms.limits.customblogdomain": "Custom Blog Domain",
        "cloudpricing.features.pim.title": "Shop & Products",
        "cloudpricing.features.pim.limits.customeramount": "Customers",
        "cloudpricing.features.pim.limits.productamount": "Products",
        "cloudpricing.features.pim.limits.supplieramount": "Suppliers",
        "cloudpricing.features.pim.limits.productvariants": "Product Variants",
        "cloudpricing.features.extension.limits.amount": "Backoffice Extensions",
        "cloudpricing.features.calendar.limits.amount": "Calendars",
        "cloudpricing.features.files.limits.gbamount": "Storage (in GB)",
        "cloudpricing.features.forms.limits.amount": "Forms",
        "cloudpricing.features.internationalization.title": "Internationalization",
        "cloudpricing.features.products.limits.amount": "Amount",
        "cloudpricing.features.products.limits.variants": "Product Variants",
        "cloudpricing.features.users.limits.amount": "User Count",
        "cloudpricing.features.email.limits.customemailprovider": "Custom Email Provider",
        "cloudpricing.features.email.limits.templatesamount": "E-Mail Templates",
        "cloudpricing.features.devices.limits.amount": "External Devices",
        "cloudpricing.features.configuration.title": "Configurations",
        "cloudpricing.features.impex.title": "Import / Export",
        "cloudpricing.features.custombackoffices.limits.amount": "Custom Backoffice Modules",
        "cloudpricing.features.custom.limits.datatypeamount": "Custom Data Types"
    };
}
exports.cloudCommon_en_us = cloudCommon_en_us;
